import {useEffect, useState} from 'react';

import {getPreviouslyApprovedChangeRequestById} from 'src/openapi/apis/ChangeRequestControllerApi';
import {getEventById} from 'src/openapi/apis/EventControllerApi';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {ChangeRequestStatus} from 'src/openapi/models/ChangeRequestStatus';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';
import {useAppDispatch} from 'src/store';

export const usePreviouslyApprovedEventInfo = (
    changeRequest: ChangeRequest,
): EventDetailInfo | null => {
    const dispatch = useAppDispatch();
    const [previouslyApprovedEvent, setPreviouslyApprovedEvent] = useState<EventDetailInfo | null>(null);

    useEffect(() => {
        const {id: changeRequestId, status, event, triggerAttachments} = changeRequest || {};
        const eventId = Number(event?.id);

        if (changeRequestId && eventId) {
            const fetchData = async () => {
                const response =
                    await dispatch(getPreviouslyApprovedChangeRequestById({id: changeRequestId}));

                if (response.payload.success) {
                    const {event: eventInfo, triggerAttachments: attachments} = response.payload.data;
                    setPreviouslyApprovedEvent({...eventInfo as EventDetailInfo, triggerAttachments: attachments});
                    return;
                }

                if (status === ChangeRequestStatus.APPROVED || status === ChangeRequestStatus.REJECTED) {
                    setPreviouslyApprovedEvent({...event as EventDetailInfo, triggerAttachments});
                    return;
                }

                const eventByIdResponse = await dispatch(getEventById({id: eventId}));

                if (eventByIdResponse.payload.success) {
                    setPreviouslyApprovedEvent(eventByIdResponse.payload.data);
                }
            };

            fetchData();
        }
    }, [changeRequest, dispatch]);

    return previouslyApprovedEvent;
};
